module.exports = __webpack_public_path__ + "img/info7-img.cb862b00.svg";